var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 21 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0015 2.00016H10.0008L8.00065 0H2.00016C0.900073 0 0.0100008 0.900073 0.0100008 2.00016L0 14.0011C0 15.1012 0.900073 16.0013 2.00016 16.0013H18.0015C19.1016 16.0013 20.0016 15.1012 20.0016 14.0011V4.00033C20.0016 2.90024 19.1016 2.00016 18.0015 2.00016ZM18.0015 14.0011H2.00016V4.00033H18.0015V14.0011ZM9.99081 5.00041L8.5807 6.41052L10.1608 8.00065H6.00049V10.0008H10.1608L8.5707 11.5909L9.99081 13.0011L14.0011 9.01073L9.99081 5.00041Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.d04f5dd4.svg";
export { ForwardRef as ReactComponent };